import { render } from "./transferV2.vue?vue&type=template&id=8ad99d78&scoped=true"
import script from "./transferV2.vue?vue&type=script&lang=js"
export * from "./transferV2.vue?vue&type=script&lang=js"

import "./transferV2.vue?vue&type=style&index=0&id=8ad99d78&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8ad99d78"

export default script